// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import {ButtonLink} from 'sail/Button';
import {webhook} from 'sail/Icon/Assets';
import {CompactTooltip} from 'sail/Tooltip';
import {useSequenceDiagram} from 'docs/data/diagram';

import './SequenceDiagram.scss';

type SequenceDiagramActionNodeData = {|
  text: React.Node,
  event?: string,
  span?: number,
|};

type SequenceDiagramActionNodeProps = {|
  data: SequenceDiagramActionNodeData,
|};

export const SequenceDiagramActionNode = ({
  data,
}: SequenceDiagramActionNodeProps) => {
  const {event, text} = data;
  const span = data.span || 1;
  const {height, segmentWidth} = useSequenceDiagram();
  const nodeWidth = segmentWidth * 0.7;
  // If we don't have a segment width set yet, render the
  // nodes with a max-width of 200px so we can get their initial dimensions and position them
  const style =
    nodeWidth > 0 ? {width: `${nodeWidth * span}px`} : {maxWidth: '200px'};

  return (
    <Box
      className="SequenceDiagramActionNode"
      flex={{alignItems: 'center', justifyContent: 'center'}}
      style={{
        height: height > 0 ? `${height}px` : 'auto',
        ...style,
      }}
      padding={8}
    >
      <Handle
        type="target"
        id="top"
        position={Position.Top}
        style={{bottom: '100%', left: '50%'}}
      />
      <Handle
        type="target"
        id="left"
        position={Position.Left}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Left}
        id="left"
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        style={{left: '50%', top: '100%'}}
      />
      <Box flexBasis="100%" padding={{horizontal: 16}}>
        {' '}
        <BodyAlt align="center">{React.Children.toArray(text)}</BodyAlt>
        {event && (
          <Box className="SequenceDiagramActionNode-event">
            <CompactTooltip
              context={
                <ButtonLink
                  color="gray900"
                  icon={webhook}
                  label={event}
                  hideLabel
                />
              }
              label={event}
            />
          </Box>
        )}
      </Box>
      <Handle
        type="target"
        id="right"
        position={Position.Right}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{top: '50%'}}
      />
    </Box>
  );
};
